export default {
  format(value: number, decimal: number = 2) {
    return value.toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: decimal,
      maximumFractionDigits: decimal,
    })
  },
  formatNumeral(value: number, decimal: number = 2) {
    return value.toLocaleString('en-US', {
      minimumFractionDigits: decimal,
      maximumFractionDigits: decimal,
    })
  },
}
